<template>
  <v-dialog v-model="dialog" persistent max-width="560px">

    <r-cookie-consent
      :form="form"
      @onSetConsent="onSetConsent"
      @onDeclineAll="onDeclineAll"
    ></r-cookie-consent>

  </v-dialog>
</template>

<script>
import { CookieConsentUtils } from '../../../legacy/researcher/modules/common/modules/cookie/utils/cookie-consent.utils';
import { cookieConsent } from '../../../legacy/researcher/modules/common/modules/cookie/utils/cookie-consent.strategy';
import CookieConsent from '../../../respondent-v2/src/components/common/cookie-consent.vue';

export default {
  components: {
    'r-cookie-consent': CookieConsent
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show(newState) {
      // Refresh the form data when the dialog is opened
      this.form = cookieConsent.get()
        ? CookieConsentUtils.mapConsentPreferencesToProperties(cookieConsent.get())
        : CookieConsentUtils.getDefaultConsent();

      this.dialog = newState;
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    onSetConsent(consent) {
      this.$emit('onSetConsent', consent);
    },
    onDeclineAll() {
      this.$emit('onDeclineAll');
    }
  },
};
</script>
